import React from 'react';
import { Input, Button, Dropdown, Grid } from 'semantic-ui-react';
import Checkbox from '@material-ui/core/Checkbox';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import getFormatedDate from '../../../functions/date';

class OtherCharge extends React.Component {

  state = {
    selectedType: 'Purchaser', data: [], customer: [], invoice_date: getFormatedDate(new Date(), 'toDate')
  }

  componentDidMount() {
    this.getPurchaser();
  }

  getPurchaser() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    this.setState({ load: true, message: 'Getting Purchaser Details!!!!' });
    $.ajax({
      type: 'POST',
      data: { 'userId': userId, 'where': 'Purchase-Detail' },
      url: Server() + 'purchaser/getpurchaser2.php',
      success: function(data) {
        let purchaseState;
        try {
          data = JSON.parse(data);
          context.getCustomer(data);
        } catch (e) { alert('Error To Get Purchaser!!!') }
      },
      error: function(err) {
        context.setState({ load: false, });
        alert('Try again!!!!')
      }
    });
  }

  getCustomer(data) {
    let context = this;
    $.ajax({
      type: 'POST',
      url: Server() + 'customer/getallcustomer.php',
      success: function(customer) {
        try {
          customer = JSON.parse(customer);
          context.setState({ data, customer, load: false })
        } catch (e) { alert('Error To Get Customer!!!'); context.setState({ load: false }) }
      },
      error: function(err) {
        context.setState({ load: false, });
        alert('Try again!!!!')
      }
    });
  }

  getCustomerDropdown() {
    let option = [];
    try {
      this.state.customer.map((c) => {
        option.push({ key: c.id+'->'+c.name+'->'+c.mobile, text: c.id+'->'+c.name+'->'+c.mobile, value: c.id })
      })
    } catch (e) {
    }
    return option;
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleCheckBox = name => event => {
    if (event.target.checked) {
      this.setState({ selectedType: 'Customer', dropdown: '', selectedPurchaser: '' })
    }
    else {
      this.setState({ selectedType: 'Purchaser', dropdown: '', selectedPurchaser: '' })
    }
  }


  purchaser = event => {
    let val = event.target.value;
    let value = val.split('->')[0];
    let state = val.split('->')[2];
    let gstn, address_id;
    this.state.data.map((y) => {
      if (y.id == value && y.state == state) {
        gstn = y.gstn;
        address_id = y.address_id;
      }
    });
    this.setState({ selectedPurchaser: value, state: state, gstn: gstn, dropdown: event.target.value, address_id })
    this.props.upDateState(state);
  };

  customer = event => {
    let val = event.target.value;
    let value = val.split('->')[0];
    let data = this.state.customer;
    let state, gstn;
    data.map((z) => {
      if (z.id == value) { state = z.state; gstn = z.GSTIN; }
    })
    this.setState({ selectedPurchaser: value, state: state, gstn: gstn, dropdown: event.target.value, address_id: value })
    this.props.upDateState(state);
  }

  getPurchaserValue() {
    return this.state.selectedPurchaser;
  }

  getInvoiceValue() {
    return this.state.invoice;
  }

  getInvoiceDateValue() {
    return this.state.invoice_date;
  }

  getPurchaserAddressValue() {
    return this.state.address_id;
  }

  getSelectTypeValue() {
    return this.state.selectedType;
  }

  render() {
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={5}>
            { this.state.selectedType == 'Purchaser' ?
              (
                <div>
                  Select Purchaser
                  <datalist id="suggestionPurchaser">
                      {this.state.data.map((y) => {
                        return (
                          <option id='box'>{y.id + '->' + y.name+ '->' + y.state}</option>
                        )
                      })}
                  </datalist>
                  <input style={{height: 35, width: '100%'}} onChange={this.purchaser} autoComplete="on"
                  list="suggestionPurchaser" value={this.state.dropdown} />
                </div>
              ):
              (
                <div>
                  Select Customer
                  <datalist id="suggestions">
                      {this.state.customer.map((y) => {
                        return (
                          <option id='box'>{y.id + '->' + y.name+ '->' + y.state}</option>
                        )
                      })}
                  </datalist>
                  <input style={{height: 35, width: '100%'}} onChange={this.customer} autoComplete="on"
                  list="suggestions" value={this.state.dropdown} />
                </div>
              )
            }
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <div>{"GSTIN: "+this.state.gstn}</div>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <div>{"State: "+this.state.state}</div>
              </Grid.Column>
            </Grid>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Checkbox checked={this.state.check} style={{marginTop: '2%'}} onChange={this.handleCheckBox('Customer')}
              value="Check" /> Purchase from Customer
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}> Invoice<br/>
            <Input onChange={this.handleChange('invoice')} value={this.state.invoice} fluid focus />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={3}> Invoice Date<br/>
            <input type="date" id="date" value={this.state.invoice_date}
              style={{width: '100%', height: 35 }} onChange={this.handleChange('invoice_date')} />
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default OtherCharge;
